export default __webpack_public_path__ + "static/media/client1.48769f72.jpg";